const routes = [
  {
    path: '/form-builder',
    name: 'form-builder',
    meta: {
      authRequired: true,
      roles: ['Admin']
    },
    component: () => import('./Index.vue')
  },
  {
    path: '/form-builder/new',
    name: 'form-builder-new',
    meta: {
      authRequired: true,
      roles: ['Admin']
    },
    component: () => import('./Builder.vue')
  },
  {
    path: '/form-builder/:id/edit',
    name: 'form-builder-edit',
    meta: {
      authRequired: true,
      roles: ['Admin']
    },
    component: () => import('./Builder.vue')
  },
  {
    path: '/form-builder/templates',
    name: 'form-builder-templates',
    meta: {
      authRequired: true,
      roles: ['Admin']
    },
    component: () => import('./templates/Index.vue')
  },
  {
    path: '/form-builder/thank-you-pages',
    name: 'form-builder-thank-you-pages',
    meta: {
      authRequired: true,
      roles: ['Admin']
    },
    component: () => import('./thank-you-pages/Index.vue')
  },
  {
    path: '/form-builder/thank-you-pages/new',
    name: 'form-builder-thank-you-pages-new',
    meta: {
      authRequired: true,
      roles: ['Admin']
    },
    component: () => import('./thank-you-pages/BuilderPage.vue')
  },
  {
    path: '/form-builder/thank-you-pages/:id/edit',
    name: 'form-builder-thank-you-pages-edit',
    meta: {
      authRequired: true,
      roles: ['Admin']
    },
    component: () => import('./thank-you-pages/BuilderPage.vue')
  }
]

export { routes }
export default routes
